import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  type?: 'website' | 'article';
  url?: string;
  image?: string;
  schema?: object;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  type = 'website',
  url = 'https://turbobetto.com',
  image = 'https://turbobetto.com/images/logo.webp',
  schema,
}) => {
  const fullUrl = url.startsWith('http') ? url : `https://turbobetto.com${url}`;

  const defaultSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'TurboBetto',
    url: 'https://turbobetto.com',
    description: 'UK Casino Offers Reviews and Comparisons',
    publisher: {
      '@type': 'Organization',
      name: 'TurboBetto',
      logo: {
        '@type': 'ImageObject',
        url: 'https://turbobetto.com/images/logo.webp',
      },
    },
  };

  const finalSchema = schema || defaultSchema;

  return (
    <Helmet>
      <title>{title} | TurboBetto</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={`${title} | TurboBetto`} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${title} | PariSport France`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;

